<script>

import { createEventDispatcher } from 'svelte';

export let value = 0;
export let min = null;
export let max = null;

const dispatch = createEventDispatcher();

function add()
{
	let n = value;

	n += this;

	if (min != null)
	{
		n = Math.max(n, min);
	}

	if (max != null)
	{
		n = Math.min(n, max);
	}

	if (n != value)
	{
		let stop = false;

		dispatch('update', {
			value,
			updated: n,
			stop: ()=>{stop = true}
		});

		if (!stop)
		{
			value = n;
		}
	}
}

</script>

<div class="flex gap-2 items-center">
	<div on:click="{add.bind(-1)}" class="rounded-full cursor-pointer text-sm bg-dark bg-opacity-50 border-0 text-white w-6 h-6 flex items-center justify-center select-none">-</div>
	<input bind:value={value} class="border border-dark border-opacity-10 w-14 px-3">
	<div on:click="{add.bind(1)}" class="rounded-full cursor-pointer text-sm bg-dark bg-opacity-50 border-0 text-white w-6 h-6 flex items-center justify-center select-none">+</div>
</div>